// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubProfileCard-cls1__c9ffb86a1a78032b1445","cls2":"ImpactHubProfileCard-cls2__f0b6b17c49bd769da6d9 ImpactHubProfileCard-cls1__c9ffb86a1a78032b1445"};